import React from 'react'
import { createRoot } from 'react-dom/client'

import { Modal } from '@fourthwall/components'
import { captureException, initSentry } from '@fourthwall/sentry'
import { AIKitApiClient } from '@fourthwall/services/dist/AIKitApiClient'
import { AnalyticsApiClient } from '@fourthwall/services/dist/AnalyticsApiClient'
import { BespokeProductsApiClient } from '@fourthwall/services/dist/BespokeProductsApiClient'
import { CreatorIntegrationsApiClient } from '@fourthwall/services/dist/CreatorIntegrationsApiClient'
import { DashboardApiClient } from '@fourthwall/services/dist/DashboardApiClient'
import { DashboardV2ApiClient } from '@fourthwall/services/dist/DashboardV2ApiClient'
import { GiftsApiClient } from '@fourthwall/services/dist/GiftsApiClient'
import { GiveawayConfigApiClient } from '@fourthwall/services/dist/GiveawayConfigApiClient'
import { GiveawayContributionApiClient } from '@fourthwall/services/dist/GiveawayContributionApiClient'
import { HasuraApiClient } from '@fourthwall/services/dist/HasuraApiClient'
import { KudosApiClient } from '@fourthwall/services/dist/KudosApiClient'
import { MembershipsApiClient } from '@fourthwall/services/dist/MembershipsApiClient'
import { MembershipsCreatorApiClient } from '@fourthwall/services/dist/MembershipsCreatorApiClient'
import { MembershipsCreatorV2ApiClient } from '@fourthwall/services/dist/MembershipsCreatorV2ApiClient'
import { NotificationShopPreferencesApiClient } from '@fourthwall/services/dist/NotificationShopPreferencesApiClient'
import { SamplesBudgetApiClient } from '@fourthwall/services/dist/SamplesBudgetApiClient'
import { ShippingApiClient } from '@fourthwall/services/dist/ShippingApiClient'
import { ShopUsersApiClient } from '@fourthwall/services/dist/ShopUsersApiClient'
import { ShopsApiClient } from '@fourthwall/services/dist/ShopsApiClient'
import { errorLoggerInterceptor, isDeployed } from '@fourthwall/utils/dist/dev'

import { Root } from './Root'

initSentry({ appName: 'creator-dashboard' })

if (isDeployed()) {
  const interceptor = errorLoggerInterceptor(captureException)

  AIKitApiClient.addErrorResponseInterceptor(interceptor)
  AnalyticsApiClient.addErrorResponseInterceptor(interceptor)
  BespokeProductsApiClient.addErrorResponseInterceptor(interceptor)
  CreatorIntegrationsApiClient.addErrorResponseInterceptor(interceptor)
  DashboardApiClient.addErrorResponseInterceptor(interceptor)
  DashboardV2ApiClient.addErrorResponseInterceptor(interceptor)
  GiftsApiClient.addErrorResponseInterceptor(interceptor)
  GiveawayConfigApiClient.addErrorResponseInterceptor(interceptor)
  GiveawayContributionApiClient.addErrorResponseInterceptor(interceptor)
  HasuraApiClient.addErrorResponseInterceptor(interceptor)
  KudosApiClient.addErrorResponseInterceptor(interceptor)
  MembershipsApiClient.addErrorResponseInterceptor(interceptor)
  MembershipsCreatorApiClient.addErrorResponseInterceptor(interceptor)
  MembershipsCreatorV2ApiClient.addErrorResponseInterceptor(interceptor)
  NotificationShopPreferencesApiClient.addErrorResponseInterceptor(interceptor)
  SamplesBudgetApiClient.addErrorResponseInterceptor(interceptor)
  ShippingApiClient.addErrorResponseInterceptor(interceptor)
  ShopUsersApiClient.addErrorResponseInterceptor(interceptor)
  ShopsApiClient.addErrorResponseInterceptor(interceptor)
}

const rootElement = document.getElementById('root')

if (rootElement) {
  Modal.setAppElement(rootElement)
}

const root = createRoot(document.getElementById('root')!)

root.render(<Root />)
